export default __webpack_public_path__ + "static/media/Mohr-Siebeck-Logo-trasp_2017.7333b28c.png";